import {
  JobAnalysisResponse,
  JobIndustryResponse,
} from '@doda/api-client/aspida/@types';
import { LinkList } from '../../LinkList';
import { nonNullableText } from '../createLinkList';

/**
 * 業種の関連リンクPropsを生成する
 * @param jobIndustryResponse
 * @param jobAnalysisResponse
 * @returns LinkList 業種の関連リンク
 */
export const createIndustryLinkList = (
  jobIndustryResponse?: JobIndustryResponse,
  jobAnalysisResponse?: JobAnalysisResponse
): LinkList => ({
  separator: '＞',
  list: [
    {
      text: jobAnalysisResponse?.industryLName ?? '',
      href: jobIndustryResponse?.industryLURL ?? '',
      count: jobIndustryResponse?.industryLCount,
    },
    {
      text: jobAnalysisResponse?.industrySName ?? '',
      href: jobIndustryResponse?.industrySURL ?? '',
      count: jobIndustryResponse?.industrySCount,
    },
  ].filter(nonNullableText),
});
